import root from 'window-or-global';
import {operatingSystem} from '../constants';
import {OperatingSystemNames} from '../constants/OperatingSystem';

/**
 * Helper to get an imported asset's path when used in JSX to make sure SSR and client paths match
 *
 * Prepend the root webpack asset path if it exists so server/client resource paths match
 * Then strip out intermediate relative pathing to avoid http://path/./resource
 */
export const getAssetPath = asset => {
    if (!asset) return undefined;
    if (/^data:image/.test(asset) || /^http/.test(asset)) return asset;

    return `${root.__webpack_asset_path || ''}${asset}`.replace(/\/\.\//, '/');
};

/**
 *  This gets set in `app.platform` in the store, so probably doesn't need to be called directly
 *  @returns {string}
 */

export const getPlatform = () => {
    if (root.navigator) {
        const {appVersion, userAgent} = root.navigator;
        const {navigators} = operatingSystem;

        for (const OS in OperatingSystemNames) {
            if (OperatingSystemNames.hasOwnProperty(OS)) {
                if (appVersion && appVersion.includes(navigators[OperatingSystemNames[OS]])) {
                    if (OperatingSystemNames[OS] !== OperatingSystemNames.WINDOWS) {
                        return OperatingSystemNames[OS];
                    }
                    // check for 64 bit or 32 bit windows
                    if (!userAgent.includes('WOW64') && !userAgent.includes('Win64')) {
                        return OperatingSystemNames.WIN32;
                    }
                    return OperatingSystemNames.WINDOWS;
                }
            }
        }
    }
    return null;
};

/**
 * Checks if all items in the offer are compatible with the users current device
 *
 * @param {Array} items catalogItems
 * @param {String} userPlatform DieselUtils getPlatform(), string representing the users current OS
 */

export const userPlatformIsFullySupported = (catalogItems, userPlatform) => {
    // can be improved by using array.filter and array.reduce
    const supportedPlatforms = [];
    catalogItems.forEach(item => {
        // SupportedPlatforms is a comma-delimited string
        // it is a custom attribute as opposed to first class citizen for query performance
        const customAttributes = item.get('customAttributes');
        if (customAttributes) {
            customAttributes.forEach(attr => {
                if (attr.get('key') === 'SupportedPlatforms') {
                    // Makes array of supported platforms, by splitting the string from the db
                    const supportedPlatformsForItem = [attr.get('value').split(',')];
                    supportedPlatforms.push(supportedPlatformsForItem);
                }
            });
        }
    });

    return supportedPlatforms.every(supportedPlatformsForItem =>
        supportedPlatformsForItem.includes(userPlatform)
    );
};

export const userIsOnMobile = () => {
    const userPlatform = getPlatform();
    return !!(userPlatform === 'iOS' || userPlatform === 'Android');
};

export const isWindows = () =>
    root.navigator && root.navigator.appVersion && root.navigator.appVersion.includes('Win');

export const isMac = () =>
    !!(root._epicGamesNav && root._epicGamesNav.browser && root._epicGamesNav.browser.mac);

export default {
    getAssetPath,
    getPlatform,
    userIsOnMobile
};
